export default __webpack_public_path__ + "static/media/day6.5a4c4cb1.png";